import Vue from 'vue'
import Vuex from 'vuex';
import {WidgetState} from "@/apps/MyStudyChoiceAuthenticationWidget/models/store-viewmodel";
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters
})
